import { ref } from 'vue'

export function useScrollProgress() {
  const activeSection = ref('intro')
  const progress = ref(0)
  
  const sections = [
    'intro',
    'ingredients', 
    'steps',
    'community',
    'comments'
  ]
  
  const updateActiveSection = () => {
    const scrollPosition = window.scrollY + 120 // 偏移量以适应固定头部
    
    for (const sectionId of sections) {
      const section = document.getElementById(sectionId)
      if (section) {
        const sectionTop = section.offsetTop
        const sectionHeight = section.offsetHeight
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          activeSection.value = sectionId
          break
        }
      }
    }
    
    // 更新进度条
    const totalHeight = document.body.scrollHeight - window.innerHeight
    progress.value = (window.scrollY / totalHeight) * 100
  }
  
  const initScrollListener = () => {
    window.addEventListener('scroll', updateActiveSection)
    updateActiveSection() // 初始调用
  }
  
  const cleanupScrollListener = () => {
    window.removeEventListener('scroll', updateActiveSection)
  }
  
  return {
    activeSection,
    progress,
    initScrollListener,
    cleanupScrollListener
  }
}